<template>
  <div id="app" v-loading.fullscreen="loading">
    <Header></Header>
    <b-modal id="postTopic" centered scrollable size="xl">
      <template v-slot:modal-title>
        <h3 style="cursor: pointer" @click="goToTopicEdit" class="text-center">
          新建话题
          <font-awesome-icon icon="external-link-alt" />
        </h3>
      </template>

      <template v-slot:modal-footer="{ cancel }">
        <el-button @click="cancel()">取消</el-button>
      </template>
      <TopicPostComponent
        v-if="user"
        @close="closePostTopic"
      ></TopicPostComponent>
    </b-modal>
    <component v-bind:is="layout" class="content"></component>
  </div>
</template>

<script>
import Header from "./components/Header.vue";
import TopicLayout from "./layouts/topic.vue";
import EmptyLayout from "./layouts/empty.vue";
import Event from "./event.js";
import ProfileLayout from "./layouts/profile.vue";
import { mapMutations } from "vuex";
import { mapState } from "vuex";
import TopicPostComponent from "./components/TopicPostComponent.vue";

export default {
  name: "App",
  metaInfo: {
    title: "海外华人论坛",
    titleTemplate: "%s - 99华人网",
    meta: [
      {
        vmid: "description",
        name: "description",
        content:
          "99华人网包括跳蚤市场，房屋出租，汽车买卖，求职招工四大热门版块，陆续添加其他热门板块，秉承社区用户至上的原则，同时鼓励言论自由，拥有现代化的论坛设计，简洁清晰的交互界面，致力于发展成为北美华人必看的最大华人论坛！"
      },
      {
        vmid: "og:title",
        name: "og:title",
        content: "99华人网-房、车、物、职四大热门板块"
      },
      {
        vmid: "og:description",
        name: "og:description",
        content:
          "99华人网包括跳蚤市场，房屋出租，汽车买卖，求职招工四大热门版块，陆续添加其他热门板块，秉承社区用户至上的原则，同时鼓励言论自由，拥有现代化的论坛设计，简洁清晰的交互界面，致力于发展成为北美华人必看的最大华人论坛！"
      },
      {
        vmid: "og:image",
        name: "og:image",
        content: "https://www.99huaren.com/logo_w_slogan.png"
      },
      {
        vmid: "og:type",
        name: "og:type",
        content: "website"
      },
      {
        vmid: "og:url",
        name: "og:url",
        content: "https://www.99huaren.com"
      }
    ]
  },
  computed: {
    ...mapState(["token", "layout", "loading", "currentCategoryId", "user"])
  },
  components: {
    Header,
    topic: TopicLayout,
    empty: EmptyLayout,
    profile: ProfileLayout,
    TopicPostComponent
  },
  watch: {
    user() {
      this.listen();
    }
  },
  beforeMount: function() {
    // this.checkTenant(); //delete the next line: this.modifyCategories();
    this.modifyCategories();
  },
  mounted: function() {
    if (this.token) {
      this.loginWithToken(this.token);
    }
  },
  methods: {
    ...mapMutations([
      "loginWithToken",
      "modifyCategories",
      "goToSubdomain",
      "setCity",
      "setCities"
    ]),
    closePostTopic: function() {
      this.$bvModal.hide("postTopic");
    },
    goToTopicEdit() {
      window.open("/topics", "_blank");
    },
    listen: function() {
      if (!this.user) return;
      window.Echo.private("users." + this.user.id)
        .notification(noti => {
          if (noti.type === "App\\Notifications\\AddPin") {
            this.user.pin_count = this.user.pin_count + noti.count;
          }
          this.user.notification_count++;

          Event.$emit("comment.notification.received");
        })
        .listen("MessageCreated", response => {
          // var chatHistory = $('.chat-history');
          let message = JSON.parse(response.message);
          // if (chatHistory.length) {
          // }

          Event.$emit("message.received", message);

          //Event.$emit('dm.notification.received');
          // confirm message notification
          if (this.user.id !== message.user_id) {
            this.user.message_count++;
          }
        });
    },
    getCity: function() {
      this.$axios.get("/cities/me").then(res => {
        localStorage.setItem("city", res.data.id);
        this.goToSubdomain(res.data.id);
      });
    },
    checkTenant: function() {
      this.$axios.get("/cities").then(res => {
        this.setCities(res.data);
        //localStorage.getItem("city");
        var cityIds = res.data.map(function(c) {
          return c.id;
        });
        if (
          location.pathname !== "/" &&
          (location.hostname.startsWith("99huaren") ||
            location.hostname.startsWith("www.99huaren"))
        ) {
          return;
        }

        if (
          location.hostname.startsWith("99huaren") ||
          location.hostname.startsWith("www.99huaren")
        ) {
          // this.setCity("");
          this.getCity();
          return;
        }
        this.modifyCategories();

        if (
          location.hostname !== "www.99huaren.com" &&
          location.hostname.includes(".99huaren")
        ) {
          let s = location.hostname.split(".99huaren");
          if (localStorage.getItem("city") !== s[0] && cityIds.includes(s[0])) {
            localStorage.setItem("city", s[0]);
          }
          this.setCity(s[0]);
        } else {
          var c = localStorage.getItem("city");
          if (c && cityIds.includes(c)) {
            this.goToSubdomain(localStorage.getItem("city"));
          } else {
            this.getCity();
          }
        }
      });
    }
  }
};
</script>
